// s-date 时间格式过滤
export const changeTimeType = val => {
  if (!val) {
    return ''
  }
  var timer = val
  timer = new Date(timer)
  // console.log(timer)
  const year = timer.getFullYear()
  var month = timer.getMonth() + 1
  month = month < 10 ? '0' + month : month
  var date = timer.getDate()
  date = date < 10 ? '0' + date : date
  const stringTime = year + '-' + month + '-' + date
  return stringTime
}

export default {
  changeTimeType,
}



// WEBPACK FOOTER //
// ./src/lib/filter.js